import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { ReportingPortal } from '../Components/Organisms/ReportingPortal/ReportingPortal'

@Route(RouteID.REPORTING_PORTAL)
export class ReportingPortalPage extends Component {
    render(): ReactElement {
        return <ReportingPortal />
    }
}
